import WriteYourOwn from '../WriteYourOwn';
import { connect } from 'react-redux';
import { IStoreState } from 'src/store';
import { AppointmentActionCreator, SpecsActionCreator, FrameworkActionCreator } from 'src/store/states';

const mapStateToProps = (state: IStoreState) => ({
    specData: state.Specs.specs,
    theme: state.Framework.theme,
    apptOps: state.Appointment.ApptOps,
    specDefaultDept: state.Specs.specs !== undefined ? state.Specs.specs.departmentFlag : '',
    mainPaneViewOrder: state.Framework.mainPaneViewOrder,
    vehicles: state.Vehicles.vehicles,
    selectedVehicle: state.Vehicles.selectedVehicle,
});

const mapDispatchToProps = {
    addLogEntry: FrameworkActionCreator.addLogEntry,
    UpdateApptOps: AppointmentActionCreator.UpdateApptOps,
    determineDept: AppointmentActionCreator.DetermineDept,
    getDeptSpecs: SpecsActionCreator.GetDeptSpecs,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(WriteYourOwn);